<template>
    <div v-if="condition"
         @click="$emit('click')"
         class="clickblock"
         :style="zStyle">
    </div>
</template>
<script>
export default {
    props: {
        zIndex: {
            type: Number,
            default: 100,
        },
        condition: {
            type: Boolean,
            default: true,
        },
    },
    computed: {
        zStyle () {
            return {
                zIndex: this.zIndex,
            }
        },
    },
}
</script>
<style scoped>
    .clickblock {
        position: fixed;
        top: 58px;
        right: 0;
        bottom: 0;
        left: 0;
    }
</style>
